import { ActivatedRoute } from '@angular/router';
import { TabsContainerService, BaseTabsContainer, UserService, BaseDataService, QueryParameter, TableContextMenuItem, ModalService, ModalSize, ModelData, ConfirmationDialogButtons, ModelDataService, ErrorHandlerService, NotificationService } from 'yt-ng-framework';
import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { FakDokument } from './fak-dokument';
import { FakDokumentView } from './fak-dokument-view';
import { List } from 'immutable';
import { DefaultListTabsComponent } from 'yt-ng-framework';
import { FilterWithKomitentComponent } from '../_filters/filter-with-komitent.component';
//import { ERROR_COLLECTOR_TOKEN } from '@angular/platform-browser-dynamic/src/compiler_factory';
// import { NotificationsService } from 'angular2-notifications';
import { CommentComponent } from 'src/app/lookups/_forme/comment/comment.component';
import { TranslateService } from '@ngx-translate/core';
import { Provajder } from 'src/app/admin/orgjeddefgini/userprovajder/provajder/provajder';
import { stringify } from 'querystring';
import { FakDokumentTabUpdateComponent } from './fak-dokument-tab-update.component';
import { FakDokumentIzvozView } from './izvoz/fak-dokument-izvoz-view';
import { error } from 'console';
import { HttpErrorResponse } from '@angular/common/http';
import { FakDokumentStavkaView } from './fak-dokument-stavka-view';
// import { SlanjeDokumentaMailomModalUpdateComponent } from './slanje-dokumenta-mailom/slanje-dokumenta-mailom-modal-update.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
// import { SlanjeDokumentaMailomTabsComponent } from './slanje-dokumenta-mailom/slanje-dokumenta-mailom-tabs.component';
import { FakDokumentService } from './fak-dokument-service';
import { UplataComponent } from 'src/app/lookups/_forme/uplata/uplata.component';
import { IzvodView } from 'src/app/fin/izvod/izvod-view';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { IzvodStavka } from 'src/app/fin/izvod/izvod-stavka';
import { PonoviComponent } from '../_forme/ponovi/ponovi.component';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: "yt-fak-dokument-tabs",
  templateUrl: "./fak-dokument-tabs.component.html",
  providers: [TabsContainerService],
})
export class FakDokumentTabsComponent
  extends BaseTabsContainer<FakDokumentView>
  implements OnInit
{
  @ViewChild("defaultList", { static: false })
  defaultList: DefaultListTabsComponent<FakDokumentView>;
  @ViewChild("filterFak", { static: false }) filterFak: FilterWithKomitentComponent;

  @Input() RefreshStatusClicked() {}

  @ViewChild("baseTabsUpdate", { static: false }) fakDokumentTabUpdateComponent: FakDokumentTabUpdateComponent;
  provajderGenericName: string;

  constructor(
    public tabsContainerService: TabsContainerService<FakDokumentView>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected modalService: ModalService,
    protected translateService: TranslateService,
    protected modelDataService: ModelDataService,
    protected errorService: ErrorHandlerService,
    protected fakDokumentService: FakDokumentService,
  ) {
    super(tabsContainerService, activatedRoute, userService);
  }

  ngOnInit() {
    super.ngOnInit();
  }


  Ponovi(id) {
   //let idParameter = [new QueryParameter("id", id)];
    let userRightsModelName = this.modelData.MainList.UserRightsModelName;
    //if (userRightsModelName != "faktura-izvozna"){
    //  this.baseDataService
    //    //.Get("FakDokument", "GetKopija", idParameter, FakDokumentView) //vrati posle
    //    //.subscribe((data : FakDokumentView[] ) => //vrati posle
    //    {
    //      //if (data != null) this.tabsContainerService.EmitItem(data[0]);

    //      //Maja, podatak o novom datumu dokumenta i period prometa
    //      let idParameter = new QueryParameter("id", id);

          let PonoviNaslovParameter = new QueryParameter (
            "naslov",
             "Izmenite datume"
          );
          let datumDokumentaParameter = new QueryParameter (
            "datumDokumenta",
             "'FAKDOKUMENT.DATDOK.SINGULAR'"
          );
          let periodOdParameter = new QueryParameter (
            "periodOd",
            "'FAKDOKUMENT.DATUMPROMETAOD.SINGULAR'"
          );
          let periodDoParameter = new QueryParameter (
            "periodDo",
            "'FAKDOKUMENT.DATUMPROMETADO.SINGULAR'"
          );
          let nazivForme = new QueryParameter(
            "vrstaDokumenta",
            userRightsModelName
          );

          let korekcijaParameter = new QueryParameter(
            "korekcija",
            "FAKDOKUMENT.KOREKCIJAVREDNOSTIDOKUMENTA.SINGULAR"
          );
          let objekatParameter = new QueryParameter(
            "objekat",
            "FAKDOKUMENT.KOMITENTOBJEKAT.SINGULAR"
          );
          let napomenaParameter = new QueryParameter(
            "napomena",
            "FAKDOKUMENT.NAPOMENA.SINGULAR"
          );

          let modelData = new ModelData(null);
          modelData.ModalSize = ModalSize.Md;
          modelData.UpdateComponent = PonoviComponent;

          if (modelData){
            this.modalService.ShowModal(0,modelData, null, true, [
              PonoviNaslovParameter,
              datumDokumentaParameter,
              periodOdParameter,
              periodDoParameter
              , nazivForme
              , korekcijaParameter
              , objekatParameter
              , napomenaParameter
            ])
            .result.then(   
              (result) => {
                if (result && result != ""){                   
                    //let datumDokumentaParameter = new QueryParameter("datumDok",result.datumDok);
                    //let periodOdParameter = new QueryParameter("periodOd",result.periodOd);
                    //let periodDoParameter = new QueryParameter("periodDo",result.periodDo);

                  this.baseDataService
                    .Post(userRightsModelName != "faktura-izvozna" ? "FakDokument" : "FakDokumentIzvoz",
                      "GetKopija", { "ID": id, "datumDok": result.datumDok, "periodOd": result.periodOd, "periodDo": result.periodDo, "copy_korekcija": result.copy_korekcija, "copy_objekat": result.copy_objekat, "copy_napomena": result.copy_napomena },
                      userRightsModelName != "faktura-izvozna" ? FakDokumentView : FakDokumentIzvozView)
                    .subscribe(
                      (data: any) => {
                        if (data != null) this.tabsContainerService.EmitItem(data[0]);
                      }
                      , error => {
                        if (error instanceof HttpErrorResponse) {
                          let _message;
                          _message = this.errorService.getServerMessage(error);

                          this.translateService.get(["FAKDOKUMENT.GETKOPIJA.ERROR",_message])
                          .subscribe(translate => {
                            this.modalService.ShowConfirmationDialog(translate["FAKDOKUMENT.GETKOPIJA.ERROR"], translate[_message], "warning", ConfirmationDialogButtons.Ok);
                          });
                        }
                      }
                    );
                    }

                } 
              );             
              }
              
          
        }
        //ovo ispod isto vrati posle kad proradi forma!!
        // ,error =>{
        //   if(error instanceof HttpErrorResponse){
        //     let _message;             
        //     _message = this.errorService.getServerMessage(error);
           
        //     this.translateService.get(_message)
        //     .subscribe(translate => {
        //       this.modalService.ShowConfirmationDialog("Problemi kod preuzimanja", translate, "warning", ConfirmationDialogButtons.Ok);
        //     });
        //   }
        // }
      // );
  //  }
  //  else{
  //    this.baseDataService
  //    .Get("FakDokumentIzvoz", "GetKopija", idParameter, FakDokumentIzvozView)
  //    .subscribe((data : FakDokumentIzvozView[] ) => {
  //      if (data != null) this.tabsContainerService.EmitItem(data[0]);
  //    }
  //    ,error =>{
  //      if(error instanceof HttpErrorResponse){
  //        let _message;             
  //        _message = this.errorService.getServerMessage(error);
         
  //        this.translateService.get(_message)
  //        .subscribe(translate => {
  //          this.modalService.ShowConfirmationDialog("Problemi kod preuzimanja", translate, "warning", ConfirmationDialogButtons.Ok);
  //        });
  //      }
           
  //    } 
  //  );
  //  }
  //}
prevod;

  async OsveziStatus(id, silent) {
    if (this.defaultList.mainItems.find((x) => x.ID === id).OsvezivogStatusa) {
      let idParameter = [new QueryParameter("id", id)];
      // this.baseDataService
      //   .Get("FakDokument", "OsveziStatus", idParameter, FakDokumentView)
      //   .subscribe((data: FakDokumentView[]) => {
      //     if (data != null) this.tabsContainerService.EmitItem(data[0]);
      //   });
      // console.log("idParameter" + id);
      const refreshedItem: any = await this.baseDataService 
            .Get("FakDokument","OsveziStatus",idParameter, FakDokumentView)
            .toPromise();
      // console.log("RefreshedItem" + refreshedItem[0].BrojDokumenta);
      // this.tabsContainerService.EmitItem(refreshedItem[0]);

      if (refreshedItem && refreshedItem.length > 0) {
        if (silent) {
          this.defaultList.UpdateMainItemWithoutSelectionChange(refreshedItem[0]);
        } else {
          this.tabsContainerService.EmitItem(refreshedItem[0]);
        }
      }

    } else {
      if (!silent) {
        this.translateService
        .get("EDOKUMENT.STATUS.NEMOZEDAOSVEZI")
        .subscribe((translate) => {
        this.prevod = translate

        this.modalService.ShowConfirmationDialog(
          "Obaveštenje",
        this.prevod,
          "alert",
          ConfirmationDialogButtons.Ok
        );
        });
        //window.alert(["'EDOKUMENT.STATUS.NEMOZEDAOSVEZI'"]);
        

       
      }
    }
  }

  ContextMenuClicked(contextMenuItem: TableContextMenuItem) {
    if (contextMenuItem.Action == "Ponovi") {
      let id: number = contextMenuItem.ID;
      this.Ponovi(id);
    }
    if (contextMenuItem.Action == "SendEUInvoice") {
      let id: number = contextMenuItem.ID;
      this.SendEUInvoice(id);
    }
    if (contextMenuItem.Action == "OsveziStatus") {
      let id: number = contextMenuItem.ID;
      this.OsveziStatus(id, false);
    }
    // if (contextMenuItem.Action == "CancelDocument") {
    //   let id: number = contextMenuItem.ID;
    //   this.CancelDocument(id)
    // }
    if (contextMenuItem.Action == "StornoDocument") {
      let id: number = contextMenuItem.ID;
      this.StornoDocument(id);
    }
    //if (contextMenuItem.Action == "EvidencijaUplate") {
    //  let id: number = contextMenuItem.ID;
    //  this.uplata(id);
    //}
    if (contextMenuItem.Action == "ResendDocument") {
      let id: number = contextMenuItem.ID;
      this.ResendDocument(id);
    }
    if (contextMenuItem.Action == "DeleteDocument") {
      let id: number = contextMenuItem.ID;
      this.DeleteDocument(id);
    }

    if (contextMenuItem.Action == "PrintDispatch") {
      let id: number = contextMenuItem.ID;
      this.PrintDispatch(id);
    }
    if (contextMenuItem.Action == "Download_XML_racuna") {
      let id: number = contextMenuItem.ID;
      this.Download_XML_racuna(id);
    }
  }

  SelectItemFormatDetailClicked(item){
    // this.baseDataService
    // .GetByID("FakDokument", id, FakDokument)
    // .subscribe((item: FakDokument) => {
      let brojDecimala = item.BrojDecimala;
      let formatString = "1."+ brojDecimala + "-" + brojDecimala;
      // let formatString = "1."+ 4 + "-" + 4;
      if (this.defaultList["detailTable"].TableColumns[3].Format != formatString){
      //  this.modelData.MainList.DetailList[0].TableColumns[3].Format = formatString;
      //  this.defaultList["detailTable"].RefreshData();
       this.defaultList["detailTable"].TableColumns[3].Format = formatString;   
      }

    // });
  }

  SendEUInvoice(id: number) {
    let _id: Number = id;

    this.baseDataService
      .GetByID("FakDokument", id, FakDokument)
      .subscribe((item: FakDokument) => {
        let _masterDokumID: Number = item.MasterDokumID;
        let _today: Date = new Date();
        let _datum: Date = new Date(
          item.Datum["year"],
          item.Datum["month"] - 1,
          item.Datum["day"]
        );
        let _genericName = item.GenericName;
        let _brojDecimala = item.BrojDecimala;

        if (
          new Date(_datum.toLocaleDateString()) <
          new Date(_today.toLocaleDateString())
        ) {
          this.translateService
            .get(["EDOKUMENT.DATE.DATECANNOTBEDIFFERENTFROMTODAYS"])
            .subscribe((translate) => {
              // this.notificationService.warn(
              //   translate["EDOKUMENT.DATE.DATECANNOTBEDIFFERENTFROMTODAYS"]
              // );
              this.toastrService.warning(
                translate["EDOKUMENT.DATE.DATECANNOTBEDIFFERENTFROMTODAYS"]
              );
            });
          return false;
        }
      
        if (_genericName == 'ko'){      
          let _brojPovezanihDokumenata : Number = item.UkBrPovezanihDokumenata;
          let _datumOd : Date = item.DatumPrometaOd ? new Date(item.DatumPrometaOd["year"], item.DatumPrometaOd["month"]-1, item.DatumPrometaOd["day"]) : null;
          let _datumDo : Date = item.DatumPrometaDo ? new Date(item.DatumPrometaDo["year"], item.DatumPrometaDo["month"]-1, item.DatumPrometaDo["day"]) : null;
    
          if ((_brojPovezanihDokumenata == 0 && _datumOd == null && _datumDo == null) || 
              (_brojPovezanihDokumenata == 0 && (_datumOd != null && _datumDo == null)) ||
              (_brojPovezanihDokumenata == 0 && (_datumOd == null && _datumDo != null)) ||
              ((_brojPovezanihDokumenata != 0 && (_datumOd != null && _datumDo == null)) ||
              (_brojPovezanihDokumenata != 0 && (_datumOd == null &&_datumDo != null)) ||
              (_brojPovezanihDokumenata != 0 && _datumOd != null && _datumDo != null))
              ){
    
            this.translateService.get(["EDOKUMENT.KO.MORABITIPOVEZANILIDATUMPROMETA.NASLOV","EDOKUMENT.KO.MORABITIPOVEZANILIDATUMPROMETA.OPIS"])
            .subscribe(translate => {
              this.modalService.ShowConfirmationDialog(translate["EDOKUMENT.KO.MORABITIPOVEZANILIDATUMPROMETA.NASLOV"],translate["EDOKUMENT.KO.MORABITIPOVEZANILIDATUMPROMETA.OPIS"],'warning',ConfirmationDialogButtons.Ok);
            });   
            return false;
          }
    
        }
        
        // provera da li neka stavka ima cenu sa više od 4 decimala
      // this.baseDataService.Get('FakDokumentStavka', 'CheckDecimalForSEF', [new QueryParameter('fakDokumentID', item.ID)], null)
      // .subscribe(maxDecimal =>{
      //   if (Number(maxDecimal) > 4)
        if (Number(_brojDecimala) > 4)
        {          
          this.translateService.get(["EDOKUMENT.CENA.MAXNUMBEROFDECIMALPLACEMORETHENINSEF"])
          .subscribe(translate => {
            // this.notificationService.warn(translate["EDOKUMENT.CENA.MAXNUMBEROFDECIMALPLACEMORETHENINSEF"]);  
            this.toastrService.warning(translate["EDOKUMENT.CENA.MAXNUMBEROFDECIMALPLACEMORETHENINSEF"]);   
          });
          return false; 
        }      
        else {

          var /** @type {?} */ parameters1 = [];
          var /** @type {?} */ parameter = new QueryParameter();
          parameter.Name = "masterDokumID";
          parameter.Value = _masterDokumID.toString();
          parameters1.push(parameter);
          this.baseDataService
            .Get("FakDokument", "GetDocStatusGenericName", parameters1, null)
            .subscribe((data) => {
              let salji = true;

              this.baseDataService
                .Get(
                  "FakDokument",
                  "GetDocStatusNaziv",
                  [new QueryParameter("genericName", data.toString())],
                  null
                )
                .subscribe((dataNaziv) => {
                  if (
                    data &&
                    data.toString().toLowerCase() != "unknown" &&
                    ((data.toString().toLowerCase() == "sent" &&
                      this.modalService.ShowConfirmationDialog(
                        "Obaveštenje o statusu dokumenta",
                        "Dokument je već poslat na portal.",
                        "warning",
                        ConfirmationDialogButtons.Ok
                      )) ||
                      (data.toString().toLowerCase() == "delivered" &&
                        this.modalService.ShowConfirmationDialog(
                          "Obaveštenje o statusu dokumenta",
                          "Dokument je već isporučen.",
                          "warning",
                          ConfirmationDialogButtons.Ok
                        )) ||
                      confirm(
                        "Status dokumenta je " +
                          dataNaziv.toString() +
                          ", da li zaista želite da ga pošaljete na portal?"
                      ) == false)
                  ) {
                    salji = false;
                  }
                  if (salji) {
                    //po novom preko modalnog prozora
                    let _modelData =
                      this.modelDataService.GetModelDataByPath("send-edokument");
                    let idParameter = new QueryParameter("fakdokumentID", _id);
                    let masterIdParameter = new QueryParameter(
                      "masterDokumID",
                      _masterDokumID
                    );
                    // let genericNameParameter = new QueryParameter(
                    //   "genericName",
                    //   this.baseTabsUpdate.baseUpdateComponent.baseFormGroup.get(
                    //     "GenericName"
                    //   ).value
                    // );
                    let genericNameParameter = new QueryParameter(
                      "genericName",
                      _genericName
                    );
                    let brojDecimalaParameter = new QueryParameter("brojDecimala", _brojDecimala);

                    if (_modelData) {
                      this.modalService
                        .ShowModal(0, _modelData, null, true, [
                          idParameter,
                          masterIdParameter,
                          genericNameParameter,
                          brojDecimalaParameter
                        ])
                        .result.then(
                          (item) => {
                            this.defaultList.mainItems.find(
                              (x) => x.ID === id
                            ).OsvezivogStatusa = true;
                            this.OsveziStatus(id, false);
                          },
                          (reason) => {}
                        );
                    }
                  }
                });
            });
        }});
      // });
  }

  async refreshStatus(oldToDays: number) {
    var nastalaJeGreska=false;
    let __this=this;

    const selectedState = this.defaultList.GetMainSelectionState();

    var odDana = new Date();
    odDana.setDate(odDana.getDate() - oldToDays);

    const itemsZaOsvezavanje = this.defaultList.mainItems.filter(value => {
        const d = value["Datum"];
        const jsDate = new Date(d["year"], d["month"] - 1, d["day"]); // i ovo je 00:00
        return jsDate >= odDana;   // ovde gledaš samo od tog datuma pa naviše
    });
     for (const value of itemsZaOsvezavanje) {
          const jsDate = new Date(
            value["Datum"]["year"],
            value["Datum"]["month"] - 1,
            value["Datum"]["day"]
          );

          try {
            await __this.OsveziStatus(value["ID"], true);
            console.log("OsveziStatus");
          } 
          catch (error) {
            nastalaJeGreska=true;
            console.log("nastalaJeGreska"+ value["ID"].toString());
          }
       
      };

    // this.defaultList.mainItems.forEach(function (value) {
    //   const jsDate = new Date(
    //     value["Datum"]["year"],
    //     value["Datum"]["month"] - 1,
    //     value["Datum"]["day"]
    //   );
    //   if (jsDate > odDana)
    //   {
    //     try {
    //       __this.OsveziStatus(value["ID"], true);
    //     } catch (error) {
    //       nastalaJeGreska=true;
    //     }
    //   };
    // });

    if (nastalaJeGreska)
      // console.log("Greška pri osvežavanju statusa..")
      this.translateService.get('EDOKUMENT.STATUS.NEMOZEDAOSVEZI')
      .subscribe(translate => {
        window.alert(translate);
      })

    this.filterFak.collapsed1=true;
    this.filterFak.filterFormGroup.enable();
    // this.tabsContainerService.EmitItem(selectedItem);
    setTimeout(() => {
      __this.defaultList.RestoreMainSelection(selectedState.id, selectedState.index);
    }, 0);
  
  }

  applayFilter(data) {
    this.defaultList.LoadMainItems(true, data);
    // this.filterFak.RefreshStatusClick();
  }

  ngAfterViewInit() {
 
    // setTimeout(() => {
    //   this.defaultList.filterComponent = this.filterFak;
    //   this.filterFak.ApplyFilter();
    //   if (
    //     this.modelData.MainList.UserRightsModelName == "faktura" ||
    //     this.modelData.MainList.UserRightsModelName == "fak-avansni" ||
    //     this.modelData.MainList.UserRightsModelName == "knjizno-odobrenje" ||
    //     this.modelData.MainList.UserRightsModelName == "knjizno-zaduzenje"
    //   )
    //     this.filterFak.showStatusBox = true;
    // }, 0);

    setTimeout(() => {     
      this.defaultList.filterComponent = this.filterFak;
      this.filterFak.ApplyFilter();
      if (
        this.modelData.MainList.UserRightsModelName == "faktura" ||
        this.modelData.MainList.UserRightsModelName == "fak-avansni" ||
        this.modelData.MainList.UserRightsModelName == "knjizno-odobrenje" ||
        this.modelData.MainList.UserRightsModelName == "knjizno-zaduzenje"
      )
        this.filterFak.showStatusBox = true;
        // if (this.defaultList.mainItems != null)
        //   this.filterFak.RefreshStatusClick();
    }, 1000);
    // Periodična provera inicijalizacije defaultList
    const intervalCheck = setInterval(() => {
      if (this.defaultList.mainItems) {
        clearInterval(intervalCheck); // Prekini proveru kada se inicijalizuje
        const brojDanaZaProveru = 5;
        this.refreshStatus(brojDanaZaProveru);
      }
    }, 100); // Provera na svakih 100ms
  }

  // CancelDocument(id) {

  //   this.baseDataService.GetByID('FakDokument', id, FakDokument)
  //   .subscribe((item: FakDokument) =>{

  //     this.getProvajderGenericName(item.ProvajderID)
  //     .subscribe((genericName: any) => {
  //       if(genericName== "Docloop_t" || genericName== "Docloop_p")
  //       {
  //         let idParameter = new QueryParameter("fakDokumentId", id);
  //         let naslovParameter = new QueryParameter("naslov", "COMMENT.CANCEL.SINGULAR");
  //         let labelParameter = new QueryParameter("labela", "COMMENT.CANCEL.REASON.SINGULAR");

  //         let modelData = new ModelData(null);
  //         modelData.ModalSize = ModalSize.Md;
  //         modelData.UpdateComponent = CommentComponent;

  //         if (modelData){
  //           this.modalService.ShowModal(0, modelData, null, true, [naslovParameter, labelParameter])
  //           .result
  //           .then((result)=>{
  //             if (result && result != ""){
  //               let cancelReasonParameter = new QueryParameter("cancelReason", result);
  //               this.baseDataService
  //               .Get("FakDokument", "CancelDocument", [idParameter, cancelReasonParameter], null)
  //               .subscribe((poruka) => {
  //                 this.translateService.get(['FW.MESSAGE'])
  //                   .subscribe(translate => {
  //                     setTimeout(()=>{
  //                       this.notificationService.success(translate['FW.MESSAGE'], poruka);
  //                     }, 0)
  //                     this.OsveziStatus(id, false);
  //                   });
  //               }
  //               ,error => {
  //                 throw error;
  //               }

  //               );
  //             }

  //           }, (reason) => {

  //           });
  //         }
  //       }else{
  //         this.modalService.ShowConfirmationDialog("Obaveštenje", "Ova opcija trenutno nije implementirana za SEF.", 'alert', ConfirmationDialogButtons.Ok);
  //       }
  //     });

  //   })
  // }
uplata(id){
  this.baseDataService
  .GetByID("FakDokument", id, FakDokument)
  .subscribe((item: FakDokument) => {
    let idParameter = new QueryParameter("fakDokumentId", id);
    let modelData = new ModelData(null);
    modelData.ModalSize = ModalSize.Md;
    modelData.UpdateComponent = UplataComponent;   
    if (modelData){
      this.modalService.ShowModal(0, modelData, null, true)
      .result.then(
        (result) => {
          if (result && result != ""){
                    // Ovde ide snimanje uplate u bazu i eventualno ažuriranje liste
                    // prvo proveravamo da li postoji izvod za taj dan
                    let ngbDatum: NgbDate=new NgbDate(result.datum.year, result.datum.month, result.datum.day);
                    let parametri: any = {
                      FakDokumentID: item.ID,
                      Datum: ngbDatum, 
                      Iznos: result.iznos
                    };
                    this.baseDataService
                      .Post("fakdokument", "EvidentirajUplatu", parametri, null)
                      .subscribe((data: FakDokumentView[]) => {
                        this.tabsContainerService.EmitItem(data[0])
                      },
                        (error) => {
                          console.error("Greška prilikom snimanje uplate:", error);


                          // Proveravamo da li server vraća detaljnu poruku greške
                          let errorMessage = "Nije uspelo snimanje uplate!";
                          if (error.error && error.error.error) {
                            errorMessage = error.error.error; // Uzimamo SQL poruku
                          }


                          this.modalService.ShowConfirmationDialog(
                            "Obaveštenje"
                            , errorMessage
                            , "warning"
                            , ConfirmationDialogButtons.Ok
                          );
                        }
                      );


          }
        }
      )
    }


  });

  }


  StornoDocument(id) {
    this.baseDataService
      .GetByID("FakDokument", id, FakDokument)
      .subscribe((item: FakDokument) => {
        this.getProvajderGenericName(item.ProvajderID).subscribe(
          (genericName: any) => {
            if (
              genericName == "Docloop_t" ||
              genericName == "Docloop_p" ||
              genericName == "Sef_t" ||
              genericName == "Sef_p"
            ) {
              let idParameter = new QueryParameter("fakDokumentId", id);
              // let stornoCommentParameter = new QueryParameter("stornoComment", "test");
              let naslovParameter = new QueryParameter(
                "naslov",
                "COMMENT.STORNO.SINGULAR"
              );
              let brojParameter = new QueryParameter(
                "brojDokumenta",
                item.BrojDokumenta
              );
              let label1Parameter = new QueryParameter(
                "labela1",
                "COMMENT.STORNO.REASON.SINGULAR"
              );
              let label2Parameter = new QueryParameter(
                "labela2",
                "COMMENT.STORNO.INVOICENUMBER.SINGULAR"
              );

              let modelData = new ModelData(null);
              modelData.ModalSize = ModalSize.Md;
              modelData.UpdateComponent = CommentComponent;

          if (modelData){
            this.modalService.ShowModal(0, modelData, null, true, [
              naslovParameter,
              label1Parameter, 
              label2Parameter,
              brojParameter
            ])
            .result.then(
              (result) => { 
              if (result && result != ""){
                let _result : string = result;
                let stornoCommentParameter = new QueryParameter("stornoComment", _result.split(';')[0] == '' ? 'null' : _result.split(';')[0]);
                let stornoInvoiceNumberParameter = new QueryParameter("stornoInvoiceNumber", _result.split(';')[1] == '' ? 'null' : _result.split(';')[1]);
                this.baseDataService
                .Get("FakDokument", "StornoDocument", [idParameter, stornoCommentParameter, stornoInvoiceNumberParameter], null)
                .subscribe(
                  (poruka : any) => {
                  this.translateService
                  .get(['EDOKUMENT.STORNO.SUCESS'])
                  .subscribe(translate => {
                    setTimeout(()=>{
                      // this.notificationService.success(translate['EDOKUMENT.STORNO.SUCESS'], poruka);
                      this.toastrService.success(translate['EDOKUMENT.STORNO.SUCESS'], poruka);
                    }, 0)
                    this.OsveziStatus(id, false);
                  });        
                }
                ,error => {
                  // throw error;    
                  let _message;
                  let translatedMessage: string = "";
                  if (error instanceof HttpErrorResponse) {
                    _message = this.errorService.getServerMessage(error);
                    if (_message instanceof ArrayBuffer) {
                      // _message = String.fromCharCode.apply(null, new Uint8Array(_message));
                      _message = new TextDecoder('utf-8').decode(new Uint8Array(_message));
                      let message: string = _message;
                      if (message.includes("EDOKUMENT")) {
                        let messageArray: string[] = message.split(';');
                        messageArray.forEach((element, index) => {
                          messageArray[index] = "FW.ERRORS." + element;
                        });
                        this.translateService.get(messageArray)
                          .subscribe(translate => {
                            translatedMessage = Object.keys(translate).map(key => translate[key]).join('\r\n');
                          });
                      }
                      else
                        translatedMessage = message;
                    }
                    else {
                      translatedMessage = this.errorService.getClientMessage(error.error);
                    }
                  }
                  this.modalService.ShowConfirmationDialog("Problemi kod storniranja", translatedMessage, "warning", ConfirmationDialogButtons.Ok);

                }
                
                );
              }
            },
            (reason) => {}
            );
            } else {
              this.modalService.ShowConfirmationDialog(
                "Obaveštenje",
                "Ova opcija trenutno nije implementirana za SEF.",
                "alert",
                ConfirmationDialogButtons.Ok
              );
            }
          }
        }
        );
      });
  }

  ResendDocument(id) {
    this.baseDataService
      .GetByID("FakDokument", id, FakDokument)
      .subscribe((item: FakDokument) => {
        this.getProvajderGenericName(item.ProvajderID).subscribe(
          (genericName: any) => {
            if (genericName == "Docloop_t" || genericName == "Docloop_p") {
              let idParameter = new QueryParameter("fakDokumentId", id);

          this.baseDataService
            .Get("FakDokument", "ResendDocument", [idParameter], null)
            .subscribe((poruka : any) => {
              this.translateService.get(['EDOKUMENT.RESEND.SUCESS'])
                    .subscribe(translate => {
                      setTimeout(()=>{
                        // this.notificationService.success(translate['EDOKUMENT.RESEND.SUCESS'], poruka);
                        this.toastrService.success(translate['EDOKUMENT.RESEND.SUCESS'], poruka);
                      }, 0)
                      this.OsveziStatus(id, false);
                    });        
            }
            ,error => {
              throw error;       
            }      
            );
        }
        else{
          this.modalService.ShowConfirmationDialog("Obaveštenje", "Ova opcija trenutno nije implementirana za SEF.", 'alert', ConfirmationDialogButtons.Ok);
        }
      }
      );
    });
  }


  DeleteDocument(id) {
    this.baseDataService
      .GetByID("FakDokument", id, FakDokument)
      .subscribe((item: FakDokument) => {
        // this.getProvajderGenericName(item.ProvajderID)
        // .subscribe((genericName: any) => {
        //   if(genericName== "Docloop_t" || genericName== "Docloop_p")
        //   {
        let idParameter = new QueryParameter("fakDokumentId", id);

          this.baseDataService
            .Get("FakDokument", "DeleteDocument", [idParameter], null)
            .subscribe(
              (poruka :any) => {
              this.translateService
                .get(['EDOKUMENT.DELETE.SUCCESS'])
                    .subscribe(translate => {
                      setTimeout(()=>{
                        // this.notificationService.success(
                        //   translate['EDOKUMENT.DELETE.SUCESS'],
                        //   poruka
                        //   );
                          this.toastrService.success(
                            translate['EDOKUMENT.DELETE.SUCCESS'],
                            poruka
                            );
                      }, 0)
                      this.OsveziStatus(id, false);
                    });        
            }
            ,error => {
               let _message;
                  let translatedMessage: string = "";
                  if (error instanceof HttpErrorResponse) {
                    _message = this.errorService.getServerMessage(error);
                    if (_message instanceof ArrayBuffer) {
                      // _message = String.fromCharCode.apply(null, new Uint8Array(_message));
                      _message = new TextDecoder('utf-8').decode(new Uint8Array(_message));
                      let message: string = _message;
                      if (message.includes("EDOKUMENT")) {
                        let messageArray: string[] = message.split(';');
                        messageArray.forEach((element, index) => {
                          messageArray[index] = "FW.ERRORS." + element;
                        });
                        this.translateService.get(messageArray)
                          .subscribe(translate => {
                            translatedMessage = Object.keys(translate).map(key => translate[key]).join('\r\n');
                          });
                      }
                      else
                        translatedMessage = message;
                    }
                    else {
                      translatedMessage = this.errorService.getClientMessage(error.error);
                    }
                  }
                  this.modalService.ShowConfirmationDialog("Problemi kod brisanja", translatedMessage, "warning", ConfirmationDialogButtons.Ok);
     
            }      
            ); 
      //   }else{
      //     this.modalService.ShowConfirmationDialog("Obaveštenje", "Ova opcija trenutno nije implementirana za SEF.", 'alert', ConfirmationDialogButtons.Ok);
      //   }
      // });

    });     
  }

  getProvajderGenericName(id: number) {
    var parameters = [];
    var provajderId = new QueryParameter();
    provajderId.Name = "id";
    provajderId.Value = id;
    parameters.push(provajderId);

    return this.baseDataService.Get(
      "Provajder",
      "getGenericName",
      parameters,
      null
    );
  }

  PrintDispatch(id: number) {
    this.translateService.get("FAKDISPATCH.SINGULAR").subscribe((translate) => {
      this.modalService
        .ShowPrintDialog(
          translate,
          this.modelData.MainList.EnablePrintAccountSelection,
          false
        )
        .result.then(
          (value) => {
            this.modalService
              .ShowConfirmationDialog(
                "Potvrda",
                "Štampamo i cene na otpremnici?",
                "question",
                ConfirmationDialogButtons.YesNo
              )
              .result.then(
                (result) => {
                  let stampamoCeneNaOtpremnici: boolean = result === true;
                  let controllerName: string;
                  let controllerMethodName: string;

                  if (this.modelData.MainList.PrintController) {
                    controllerName = this.modelData.MainList.PrintController;
                    controllerMethodName = "Printaj";
                  } else {
                    controllerName = this.modelData.MainList.ModelName;
                    controllerMethodName = this.modelData.MainList.PrintName;
                  }

                  this.baseDataService
                    .GetFile(controllerName, controllerMethodName, {
                      ReportPars: [
                        { Name: "ID", Value: id },
                        { Name: "PrintMethod", Value: this.modelData.MainList.PrintName },
                        { Name: "Otpremnica", Value: true },
                        { Name: "StampamoCeneNaOtpremnici", Value: stampamoCeneNaOtpremnici }
                      ],
                      WipsPars: {
                        parReportTitle: value.Title,
                        parReportSubtitle: value.SubTitle,
                        parPageNoYes: value.ShowPageCount,
                        parPageNoPosition: value.PageNoPosition,
                        parTimeZoneInfo: "Central Europe Standard Time",
                        parHeaderType: value.ReportHeaderTypes,
                        parPageFooterType: value.ReportPageTypes,
                        parCompanyAccounts: value.FirmaZrcs,
                        parIzvestajId: value.TipDokumenta,
                        parOdloziIUEregistrator: value.Eregistrator,
                      },
                    })
                    .subscribe((file) => {
                      let fileUrl = URL.createObjectURL(file);
                      window.open(fileUrl);
                    });
                },
                () => { }
              );
          },
          () => { }
        );
    });
  }
  loadingEUInvoiceInXml: boolean = false;

  Download_XML_racuna(id) {

    const item = this.defaultList.mainItems.find(x => x.ID === id);
    let _id: Number = id;

    let _genericName = item.GenericName;
    let brojDecimala = item.BrojDecimala
    let brojDokumenta = item.BrojDokumenta

    let parameters = { fakdokumentID: _id, genericName: _genericName, brojDecimala: brojDecimala };
    this.loadingEUInvoiceInXml = true;
    this.baseDataService
      .GetFile("FakDokument", "EUInvoice", parameters)
      .subscribe((result: any) => {
        this.loadingEUInvoiceInXml = false;
        var lcType = result.type;
        let fileUrl: string = URL.createObjectURL(result);
        if (lcType == "application/xml; charset=utf-8") {
          // window.open(fileUrl);
          var link = document.createElement("a");
          link.download = brojDokumenta + ".xml";
          link.href = fileUrl;
          link.click();
        } else window.open(fileUrl);
      }
        , error => {
          this.loadingEUInvoiceInXml = false;
          // throw error;
          let _message;
          let translatedMessage: string = "";
          if (error instanceof HttpErrorResponse) {
            _message = this.errorService.getServerMessage(error);
            if (_message instanceof ArrayBuffer) {
              _message = String.fromCharCode.apply(null, new Uint8Array(_message));
              let message: string = _message;
              if (message.includes("EDOKUMENT")) {
                let messageArray: string[] = message.split(';');
                messageArray.forEach((element, index) => {
                  messageArray[index] = "FW.ERRORS." + element;
                });
                this.translateService.get(messageArray)
                  .subscribe(translate => {
                    translatedMessage = Object.keys(translate).map(key => translate[key]).join('\r\n');
                  });
              }
              else
                translatedMessage = message;
            }
            else {
              translatedMessage = this.errorService.getClientMessage(error);
            }
          }
          this.modalService.ShowConfirmationDialog("Problemi kod preuzimanja", translatedMessage, "warning", ConfirmationDialogButtons.Ok);

        });
  }
}

  
  // SelektovanRed($selektovani: any): void {
  //   if ($selektovani != null) {
  //     this.baseTabsUpdate.baseUpdateComponent.baseInlineContainer.baseDetailList._model.TableColumns[3].Format = "1.4-4";
  //     this.baseTabsUpdate.baseUpdateComponent.baseInlineContainer.baseDetailList.RefreshData();
  //   }

  // }
 

  
  // SlanjeDokumenta(id: number) {
  //   this.translateService.get(this.modalService.ConvertPluralToSingular(this.modelData.BreadcrumbLabel)).subscribe((translate) => {
  //     const modalRef = this.ngbModalService.open(SlanjeDokumentaMailomModalUpdateComponent, {
  //       backdrop: 'static',
  //       keyboard: false,
  //       size: 'lg' 
  //     });
  
  //     // Prosleđivanje vrednosti
  //     modalRef.componentInstance.Title = translate;
  //     modalRef.componentInstance.ShowFirmaZrc = this.modelData.MainList.EnablePrintAccountSelection;
  //     modalRef.componentInstance.ShowAllInOneDoc = false;
  //     this.printPdf(id, {}).then((fileUrl) => {
  //       modalRef.componentInstance.pdfUrl = fileUrl; 
  //    }).catch(error => {
  //       console.error('Greška pri generisanju PDF URL-a:', error);
  //    });
  //       },
  //       () => {
  //       }
  //   );
  //   //});
  // }

  // public printPdf(ID: number, value, parameters?: any): Promise<string> {
  //   return new Promise((resolve, reject) => {
  //     let controllerName: string;
  //     let controllerMethodName: string;
  
  //     if (this.modelData.MainList.PrintController) {
  //       controllerName = this.modelData.MainList.PrintController;
  //       controllerMethodName = 'Printaj';
  //     } else {
  //       controllerName = this.modelData.MainList.ModelName;
  //       controllerMethodName = this.modelData.MainList.PrintName;
  //     }
  
  //     let reportPars = [
  //       { Name: 'ID', Value: ID },
  //       { Name: 'PrintMethod', Value: this.modelData.MainList.PrintName }
  //     ];
  
  //     if (parameters) {
  //       Object.keys(parameters).forEach(key => {
  //         reportPars.push({ Name: key, Value: parameters[key] });
  //       });
  //     }
  
  //     // Pretplatite se na Observable unutar Promise bloka
  //     this.baseDataService.GetFile(controllerName, controllerMethodName, {
  //       ReportPars: reportPars,
  //       WipsPars: {
  //         parReportTitle: value.Title,
  //         parReportSubtitle: value.Subtitle,
  //         parPageNoYes: value.ShowPageCount,
  //         parPageNoPosition: value.PageNoPosition,
  //         parTimeZoneInfo: 'Central Europe Standard Time',
  //         parHeaderType: value.ReportHeaderTypes,
  //         parPageFooterType: value.ReportPageTypes,
  //         parCompanyAccounts: value.FirmaZrcs,
  //         parIzvestajId: value.TipDokumenta,
  //         parOdloziIUEregistrator: value.Eregistrator,
  //       }
  //     }).subscribe(
  //       file => {
  //         let fileUrl = URL.createObjectURL(file);
  //         resolve(fileUrl); 
  //       },
  //       error => {
  //         reject(error); 
  //       }
  //     );
  //   });
  // }
  
// }
